import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

const DropdownHeader = ({ children, onClick }) => (
  <div className={styles.backLink} onClick={onClick}>
    {children}
  </div>
);

const Dropdown = ({ children, visible }) => (
  <div className={classnames(styles.wrapper, { [styles.visible]: visible })}>
    <div className={styles.container}>{children}</div>
  </div>
);

Dropdown.Header = DropdownHeader;

export default Dropdown;
